import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormErrorsMessagesModel} from '@sharedcommon/model/form-errors-messages.model';
import {Subject} from 'rxjs';
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'neq-form-errors-messages',
  templateUrl: './form-errors-messages.component.html',
  styleUrls: ['./form-errors-messages.component.css']
})
export class FormErrorsMessagesComponent implements OnInit, OnChanges, OnDestroy {

  destroy$ = new Subject();

  /**
   * Launche the check of the field validity
   */
  @Input() check = false;

  /**
   * form group of the input
   */
  @Input() entryFormGroup: FormGroup;

  /**
   * Form group name of the input
   */
  @Input() entryFormGroupName: string;

  /**
   * List of messages to be shown
   */
  @Input() messageList: FormErrorsMessagesModel[] = [];

  ngOnInit() {
    if (this.entryFormGroup) {
      // Subscribe to the valueChanges obs of the form group
      this.entryFormGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        // Start the check only after the first submit
        if (this.check) {
          this.showRightMessage();
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
  }

  ngOnChanges(changes: SimpleChanges) {
    // Trigger when check changes and if not undefined (changes this value in the submit function
    if (changes?.check && this.check) {
      this.showRightMessage();
    }
  }

  /**
   * Go through the list of messages and change the show value to true if a corresponding error is found in the formgroup
   */
  showRightMessage() {
    if (this.messageList && this.messageList.length > 0 && this.entryFormGroup && this.entryFormGroupName) {
      this.messageList.forEach((message: FormErrorsMessagesModel) => {
        if (this.entryFormGroup.get(this.entryFormGroupName)?.errors?.[message.errorType]) {
          message.show = true;
        } else {
          message.show = false;
        }
      });
    }
  }
}
